export const  iconList = [
    // Documents Icons
    { type: "pdf", icon: "fiv-cla fiv-icon-pdf fiv-size-md" },
    { type: "ppt", icon: "fiv-cla fiv-icon-ppt fiv-size-md" },
    { type: "pptx", icon: "fiv-cla fiv-icon-ppt fiv-size-md" },
    { type: "xls", icon: "fiv-cla fiv-icon-xls fiv-size-md" },
    { type: "csv", icon: "fiv-cla fiv-icon-csv fiv-size-md" },
    { type: "xlsx", icon: "fiv-cla fiv-icon-xls fiv-size-md" },
    { type: "doc", icon: "fiv-cla fiv-icon-doc fiv-size-md" },
    { type: "docx", icon: "fiv-cla fiv-icon-doc fiv-size-md" },
    { type: "zip", icon: "fiv-cla fiv-icon-zip fiv-size-md" },
    { type: "txt", icon: "fiv-cla fiv-icon-txt fiv-size-md" },

    // Image Icons
    { type: "png", icon: "fiv-cla fiv-icon-png fiv-size-md" },
    { type: "svg", icon: "fiv-cla fiv-icon-svg fiv-size-md" },
    { type: "jpg", icon: "fiv-cla fiv-icon-jpg fiv-size-md" },
    { type: "jpeg", icon: "fiv-cla fiv-icon-jpeg fiv-size-md" },
    { type: "gif", icon: "fiv-cla fiv-icon-gif fiv-size-md" },

    // Media File Icons
    { type: "3g2", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "3gp", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "avi", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "h264", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "m4v", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "mkv", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "mov", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "mp4", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "mpg", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "mpeg", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "rm", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "swf", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "vob", icon: "fiv-cla fiv-icon-avi fiv-size-md" },
    { type: "wmv", icon: "fiv-cla fiv-icon-avi fiv-size-md" },

    // Audio File Icons
    { type: "aif", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "cda", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "mid", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "midi", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "mp3", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "mpa", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "ogg", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "wav", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "wma", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
    { type: "wpl", icon: "fiv-cla fiv-icon-wav fiv-size-md" },
  ];
